// extracted by mini-css-extract-plugin
module.exports = {"likeButtonWrapper":"like-button-wrapper_likeButtonWrapper__v9Hwj"};